/** TODO move to _variables.scss
 * Types Field Enum
 */
export const StyleEnum = Object.freeze({
  COLOR_EXIST_ERROR: 'rgb(0, 137, 223)',
  COLOR_EXIST_ERROR_FOCUS: 'rgb(176, 207, 224)',
  COLOR_SHOW_ERROR: 'rgb(255, 0, 0)',
  COLOR_SHOW_ERROR_FOCUS: 'rgb(224, 176, 176)',
  COLOR_VALID: 'rgb(0, 128, 0)',
  COLOR_VALID_FOCUS: 'rgba(0, 128, 0, 0.548)',
  FONT_SIZE: '14px',
  FONT_COLOR: 'rgb(74, 74, 74)',
  WIDTH: '400px',
});
